import { useMe } from '@/api/me';

/**
 * Ported from legacy `useAffiliatePolicyPermissions`. In @workspace the auth
 * layer exposes `is_admin` from `/auth/me` but NOT the Keycloak resource-scope
 * map (`rsname` / `scopes`) that the legacy store held. Until UMA scope
 * inspection is wired in @workspace, we gate on `is_admin` as the nearest
 * available signal (admins have full write access server-side).
 *
 * CONCERN: non-admin CSKH/BOM/Sale users who can write Customers also get
 * affiliate write routes on the backend. That widening is NOT reflected here
 * yet — those users will see read-only UI until scope inspection is added.
 */
export function useAffiliatePolicyPermissions() {
  const { data: me } = useMe();
  const isAdmin = me?.is_admin === true;

  return {
    /** Can open create-policy drawer and submit. */
    canCreatePolicy: isAdmin,
    /** Can open edit-policy drawer and submit. */
    canUpdatePolicy: isAdmin,
    /** Can trigger delete-policy ConfirmDialog. */
    canDeletePolicy: isAdmin,
    /** Can edit the affiliate inline fields. */
    canUpdateAffiliate: isAdmin,
    /** Whether the Commission Policies tab/page should be visible at all. */
    canManagePolicies: isAdmin,
  };
}
